const getDirectionFromAlignmentAndTextDirection = (textAlignment, textDirection) => {
  if (textAlignment === "right") {
    return "rtl";
  } else if (textAlignment === "left") {
    return "ltr";
  } else {
    return textDirection && textDirection === "rtl" ? textDirection : "ltr";
  }
};

export { getDirectionFromAlignmentAndTextDirection };
//# sourceMappingURL=textDirection.js.map
